export default __webpack_public_path__ + "static/media/invoicepending.cfef7415.svg";